import { ArrowRight, Download, FileText } from "lucide-react";

const ReportsTab = ({ reportsData }) => {

    return (<>
        <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div>
               <h3 className="text-2xl font-bold text-slate-900 tracking-tight">Reports</h3>
               <p className="text-sm text-slate-500 mt-1">High-level metrics and downloadable artifact packages.</p>
            </div>

            {/* Metrics Row */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="bg-gradient-to-br from-indigo-50 to-white p-6 rounded-3xl ring-1 ring-indigo-100 shadow-sm flex flex-col items-center justify-center text-center hover:-translate-y-1 transition-transform">
                <span className="text-4xl font-black text-indigo-600 mb-2">{reportsData.complianceScore}%</span>
                <span className="text-[10px] font-bold text-indigo-900/60 uppercase tracking-widest">Readiness Score</span>
              </div>
              <div className="bg-gradient-to-br from-emerald-50 to-white p-6 rounded-3xl ring-1 ring-emerald-100 shadow-sm flex flex-col items-center justify-center text-center hover:-translate-y-1 transition-transform">
                <span className="text-4xl font-black text-emerald-600 mb-2">{reportsData.controlsPassed}</span>
                <span className="text-[10px] font-bold text-emerald-900/60 uppercase tracking-widest">Controls Passed</span>
              </div>
              <div className="bg-gradient-to-br from-rose-50 to-white p-6 rounded-3xl ring-1 ring-rose-100 shadow-sm flex flex-col items-center justify-center text-center hover:-translate-y-1 transition-transform">
                <span className="text-4xl font-black text-rose-600 mb-2">{reportsData.controlsFailed}</span>
                <span className="text-[10px] font-bold text-rose-900/60 uppercase tracking-widest">Controls Failed</span>
              </div>
              <div className="bg-gradient-to-br from-amber-50 to-white p-6 rounded-3xl ring-1 ring-amber-100 shadow-sm flex flex-col items-center justify-center text-center hover:-translate-y-1 transition-transform">
                <span className="text-4xl font-black text-amber-600 mb-2">{reportsData.openGaps}</span>
                <span className="text-[10px] font-bold text-amber-900/60 uppercase tracking-widest">Open Gaps</span>
              </div>
            </div>

            {/* Downloads Section */}
            <div>
               <h4 className="text-sm font-bold text-slate-800 mb-4 uppercase tracking-widest flex items-center gap-2">
                  <Download size={16} className="text-slate-400"/> Available Packages
               </h4>
               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                 {reportsData.downloads.map((rep, i) => (
                   <div key={i} className="p-5 bg-white ring-1 ring-slate-200/60 rounded-2xl shadow-sm flex flex-col justify-between h-40 hover:ring-indigo-400 hover:shadow-md transition-all group cursor-pointer">
                     <div className="flex justify-between items-start">
                       <div className="p-3 bg-slate-50 text-slate-500 rounded-xl ring-1 ring-slate-100 group-hover:bg-indigo-600 group-hover:text-white group-hover:ring-indigo-600 transition-all">
                         <FileText size={22} />
                       </div>
                       <span className="text-[10px] font-bold text-slate-500 bg-slate-100 px-2.5 py-1 rounded-md tracking-widest uppercase">{rep.format}</span>
                     </div>
                     <div className="mt-4">
                       <h4 className="text-base font-bold text-slate-900 mb-1 group-hover:text-indigo-600 transition-colors">{rep.title}</h4>
                       <div className="flex items-center justify-between mt-2">
                         <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider">{rep.date} • {rep.size}</p>
                         <div className="w-6 h-6 rounded-full bg-slate-50 flex items-center justify-center group-hover:bg-indigo-100 transition-colors">
                            <ArrowRight size={12} className="text-slate-400 group-hover:text-indigo-600" />
                         </div>
                       </div>
                     </div>
                   </div>
                 ))}
               </div>
            </div>
        </div>
    </>);
};

export default ReportsTab;